import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import classes from './../../assets/scss/core/elements/_backgroundVideo.module.scss';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const videoSource = require('./../../assets/images/video/bg_coding.mp4').default

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div id="Hero" className="container-md">
        <div className={innerClasses}>

          <div className={classes.Container} >
            <video autoPlay="autoplay" loop="loop" muted className={classes.Video} >
                <source src={videoSource} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className={classes.Content}>
                <div className={classes.SubContent} >
                    <h1>
                        <span className="text-color-secondary disable">Fullstack development</span> of web applications
                    </h1>
                    <p>Websites, landing pages, ECommerce and web applications for small business.</p>
                    <div>
                        <ButtonGroup>
                            <Button tag="a" color="secondary" wideMobile href="#Contact" onClick={() => {
                              document.querySelector('#Contact').scrollIntoView({ behavior: 'smooth', block: 'center' })
                            }}>
                                Contact
                            </Button>
                            <Button tag="a" color="dark" wideMobile href="#About" onClick={() => {
                              document.querySelector('#Projects').scrollIntoView({ behavior: 'smooth', block: 'center' })
                            }}>
                                Projects
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </div>

        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;